import { render, staticRenderFns } from "./OptsPosturasModal.vue?vue&type=template&id=0dd5231c"
import script from "./OptsPosturasModal.vue?vue&type=script&lang=js"
export * from "./OptsPosturasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports